<div
    class="d-flex"
    *ngIf="!oneInputField">
    <form
        [formGroup]="form"
        class="d-flex">
        <input
            type="date"
            formControlName="startDate"
            class="me-3 form-control dateRangeStyle" />
        <input
            type="date"
            formControlName="endDate"
            class="form-control dateRangeStyle" />
    </form>
    <div class="filter-btn ms-1 d-flex">
        <a
            class="d-flex align-items-center ms-1 ngx-daterangepicker-action"
            (click)="pickerDirective.open($event)">
            <img
                src="assets/images/calendar-icon.png"
                class="ngx-daterangepicker-action"
                alt="Calendar icon" />
        </a>
    </div>
</div>
<div
    *ngIf="oneInputField"
    class="one-filed-cont">
    <a
        class="d-flex align-items-center ms-1 action-open-link ngx-daterangepicker-action"
        (click)="pickerDirective.open($event)"
        >&nbsp;</a
    >
    <label class="padded-top-gray-label">Date Creation:</label>
    <div class="date-input-holder">
        <input
            class="date-selector-text"
            readonly
            [formControl]="oneInputControl"
            placeholder="Set Date" />
        <span
            class="clear-icon"
            *ngIf="clearable && oneInputControl.value"
            (click)="clearDate()"
            >×</span
        >
    </div>
</div>

<input
    type="hidden"
    ngxDaterangepickerMd
    [(ngModel)]="selectedRange"
    class="form-control dateRangeStyle"
    [showCustomRangeLabel]="true"
    [alwaysShowCalendars]="true"
    [ranges]="ranges"
    [linkedCalendars]="false"
    [showClearButton]="false"
    [locale]="{ format: 'DD/MM/YYYY', displayFormat: 'DD/MM/YYYY' }"
    (rangeClicked)="rangeClicked($event)"
    (datesUpdated)="datesUpdated($event)"
    placeholder="Select please..."
    [showCancel]="true" />
